import { TTransaction } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TransactionQuerySchema = {
  companyID: string;
  connectionID: string;
};

export const getTransactionByConnectionID = (axios: IAxiosInstance) => {
  return async (params: TransactionQuerySchema) => {
    const response = await axios.noRetry.get<IApiResponse<TTransaction>>(
      `/connections/${params.connectionID}/transactions`,
      {
        params,
      }
    );

    return response.data.data;
  };
};
